import styled from 'styled-components';
import { getColor, getSpace, mq } from '../../../stylesheets/tools';

const cursorSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 126 91" fill="{{cursorColor}}" xmlns:v="https://vecta.io/nano"><path d="M66.8218004,101.898347 L79.5590937,88.9650949 C80.1469688,88.3772198 80.1469688,87.2014697 79.5590937,86.4176363 L77.011635,83.8701776 C76.42376,83.2823025 75.2480098,83.2823025 74.4641764,83.8701776 L65.4500919,92.8842621 C64.2743417,94.0600122 62.5107165,93.2761788 62.5107165,91.7085119 L62.5107165,64.2743417 C62.5107165,59.3753827 58.5915493,55.6521739 53.8885487,55.6521739 L39.9755052,55.6521739 C37.6240049,55.6521739 35.6644213,53.6925903 35.6644213,51.34109 L35.6644213,35.6644213 C35.6644213,30.7654623 31.7452541,27.0422535 27.0422535,27.0422535 L11.3655848,27.0422535 C9.01408451,27.0422535 7.05450092,25.0826699 7.05450092,22.7311696 L7.05450092,1.76362523 C7.05450092,0.783833435 6.27066748,0 5.29087569,0 L1.76362523,0 C0.783833435,0 0,0.783833435 0,1.76362523 L0,25.2786283 C0,30.1775873 3.91916718,33.9007961 8.62216779,33.9007961 L24.2988365,33.9007961 C26.6503368,33.9007961 28.6099204,35.8603797 28.6099204,38.21188 L28.6099204,53.8885487 C28.6099204,58.7875077 32.5290876,62.5107165 37.2320882,62.5107165 L51.1451317,62.5107165 C53.496632,62.5107165 55.4562156,64.4703001 55.4562156,66.8218004 L55.4562156,91.7085119 C55.4562156,93.2761788 53.496632,94.0600122 52.5168402,92.8842621 L43.5027557,83.8701776 C42.9148806,83.2823025 41.7391304,83.2823025 40.955297,83.8701776 L38.7997551,86.6135946 C38.21188,87.2014697 38.21188,88.3772198 38.7997551,89.1610533 L51.5370484,102.094305 C53.1047152,103.661972 55.4562156,104.641764 57.6117575,104.641764 L60.3551745,104.641764 C62.9026332,104.445805 65.2541335,103.466013 66.8218004,101.898347"></path></svg>';

const getCursor = props => {
  return cursorSvg.replace('{{cursorColor}}', props.theme.siteTheme.primary.replace('#', '%23'));
};

const flex = {
  gap: '60px'
};

const customBreakPoint = '1110px';

const StyledCuratedExhibitionTeasers = styled.div`
  margin-top: ${props => (props.noMargin ? '0rem' : '15rem')};
  margin-bottom: ${props => (props.noMargin ? '0rem' : '10rem')};

  .curatedExhibitionTeasers__text-container {
    position: relative;
    padding-top: ${getSpace('xl')};
    padding-bottom: ${getSpace('xl')};
    text-align: center;

    h2,
    span {
      max-width: 80%;
      margin: auto;
      display: block;

      ${mq('m')} {
        max-width: 50%;
      }
    }
    h2 {
      font-weight: 400;
      font-size: 1.5em;
    }
  }

  .curatedExhibitionTeasers__text-container:before {
    content: '';
    border-top: 2px solid ${props => (props.isDarkPage ? 'white' : 'black')};
    position: absolute;
    top: 0;
    left: 25%;
    width: 50%;
  }

  .curatedExhibitionTeasers__stack .container__wrapper {
    display: flex;
    justify-content: flex-start;
    gap: ${flex.gap};

    ${mq('m', 'max')} {
      flex-direction: column;
    }
  }

  .curatedExhibitionTeasers__stack-boxes {
    display: grid;

    gap: ${flex.gap};
    width: 100%;

    @media screen and (min-width: ${customBreakPoint}) {
      grid-template-columns: 1fr 1fr;
      grid-auto-rows: auto;
    }
  }

  .curatedExhibitionTeasers__container {
    flex-basis: calc(50% - ${flex.gap});
    flex-grow: 100%;
    background: ${getColor('white')};
    clip-path: polygon(25px 0, 100% 0, 100% 100%, 0 100%, 0 20px);
    transition: all 0.5s ease;
    position: relative;
    width: 100%;
    height: min-content;
    display: flex;
    flex-direction: column;
    border: 2px solid black;

    &::after {
      display: block;
      content: '';
      position: absolute;
      width: 44px;
      height: 2px;
      background: black;
      z-index: 9999;
      position: absolute;
      top: 8px;
      left: -11px;
      transform: rotate(-39deg);
    }
  }

  .curatedExhibitionTeasers__container-not-stacked {
    cursor: pointer;
  }
  .curatedExhibitionTeasers__container-stacked {
    cursor: unset;
  }

  @media screen and (min-width: ${customBreakPoint}) {
    .curatedExhibitionTeasers__is-stacked-true {
      cursor: url('data:image/svg+xml;utf8,${props => getCursor(props)}'),
        auto;

      .curatedExhibitionTeasers__container:nth-of-type(1) {
        transform: translate(10%, 10%);
        z-index: 4;
      }
      .curatedExhibitionTeasers__container:nth-of-type(2) {
        transform: translate(-30%, 30%);
        z-index: 3;
      }
      .curatedExhibitionTeasers__container:nth-of-type(3) {
        transform: translate(20%, 5%);
        z-index: 2;

        @media screen and (min-width: 1250px) {
          transform: translate(25%, 5%);
        }
      }
      .curatedExhibitionTeasers__container:nth-of-type(4) {
        transform: translate(0%, -3%);
        z-index: 1;

        @media screen and (min-width: 1250px) {
          transform: translate(20%, -3%);
        }
      }
    }
  }

  .curatedExhibitionTeasers__container:hover
    .curatedExhibitionTeasers__teaser-image
    .curatedExhibitionTeasers__arrow-long {
    transform: translateX(5px);
  }

  .curatedExhibitionTeasers__teaser-text {
    padding: 1rem;
    border-top: 2px solid black;
    height: min-content;
    min-height: 195px;

    ${mq('m', 'max')} {
      max-width: unset;
      min-width: unset;
      min-height: unset;
    }

    h2,
    span,
    span * {
      color: black;
    }
  }

  .curatedExhibitionTeasers__teaser-image {
    position: relative;
    height: min-content;
    width: 100%;
    background: ${getColor('lightGray')};
    animation: loadingBg 1s linear infinite alternate;

    img {
      object-fit: cover;
      width: 100%;
      aspect-ratio: 16 / 12.5;
    }

    .curatedExhibitionTeasers__arrow-long {
      position: absolute;
      z-index: 11;
      top: ${getSpace('xs')};
      right: ${getSpace('m')};
      color: ${getColor('white')};
      transition: 0.5s transform ease, 0.25s opacity ease 0.6s;

      svg {
        width: 50px;
      }
    }

    ${mq('m')} {
      .curatedExhibitionTeasers__arrow-long-stacked {
        opacity: 0;
      }
    }
  }

  .curatedExhibitionTeasers__container-not-stacked.curatedExhibitionTeasers__login-mask {
    cursor: default;
  }

  .curatedExhibitionTeasers__container-stacked.curatedExhibitionTeasers__login-mask {
    pointer-events: none;
  }

  .curatedExhibitionTeasers__login-mask {
    background: none;
    height: 100%;
    border: none;

    &:after {
      content: unset;
    }

    & > div {
      &:after {
        display: block;
        content: '';
        position: absolute;
        width: 34px;
        height: 2px;
        background: black;
        z-index: 9999;
        position: absolute;
        top: 11px;
        left: -6px;
        transform: rotate(-39deg);
      }
      &:before {
        border: 2px solid black;
      }
    }

    * {
      color: black;
    }

    .tokenInput__container, .tokenInput__container:after {
      background: black;
    }

    .tokenInput__container:after {
      background: ${getColor('teaserPink')};
    }

    .loginMask__input {
      min-width: min(17rem, 100%);
    }

    input#tokenInput {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export default StyledCuratedExhibitionTeasers;
